[
  {
    "answerSource": "gpt_5_5_pro",
    "id": "gk-2015-lunyu",
    "material": "15.《论语?侍坐》篇，子路、曾皙、冉有、公西华分别讲述了自己的志向，孔子\n对子路的话不以为然。篇末是曾皙与孔子师生二人的对话，这一对话存在两种不同的标点，其中一种标点如下。\n\n曰：“夫子何哂由也？”\n\n曰：“为国以礼，其言不让，是故哂之。唯求则非邦也与？安见方六七十，如五六十而非邦也者？唯赤则非邦也与？宗庙会同，非诸侯而何？赤也为之小，孰能为之大？”\n\n另一种标点如下。\n\n曰：“夫子何哂由也？”\n\n曰：“为国以礼，其言不让，是故哂之。”\n\n（ ）“唯求则非邦也与？”\n\n（ ）“安见方六七十，如五六十而非邦也者？”\n\n（ ）“唯赤则非邦也与？”\n\n（ ）“宗庙会同，非诸侯而何？赤也为之小，孰能为之大？”\n",
    "modelAnswer": "GPT-5.5 pro 版本答案：\n答案：孔子。解析：在《论语·侍坐》原文语境中，这一连串的反问句均是对弟子冉有和公西华志向的评价，且是对曾皙提问的直接回答，因此说话人均为孔子。",
    "passages": [
      296
    ],
    "province": "北京",
    "questions": [
      {
        "id": "q1",
        "prompt": "① 请在括号内写出本句的说话人。（1分）",
        "score": 1,
        "sourceReview": {
          "answer": "依次为：曾皙、孔子、曾皙、孔子。第二种标点把两个“唯……非邦也与”读作曾皙的追问，其后的反问则是孔子的答复。",
          "printedScore": 1,
          "questionSha256": "6f83ccf0c47763557693abd887ae12ca10c44d94d59a8ddc4fd34cb852e9d0db",
          "sourceQIndex": 1
        }
      },
      {
        "id": "q2",
        "prompt": "② 不同的标点源于对文本的不同解读，请简要说明第二种解读与第一种的不同之处。有人认为第二种解读优于第一种，你赞成哪一种？请说明理由。（5分）",
        "score": 5,
        "sourceReview": {
          "answer": "不同之处：第一种读法是曾皙一问、孔子集中作答；第二种是师生连续三次问答。第二种还显出两人的关注点不同：孔子重在是否谦让、是否合礼；曾皙追问的则是，冉有、公西华既然同样谈治国，为何没有受到与子路相同的评价。\n可以赞成任一种，但须说明理由。赞成第一种，可从孔子集中阐明“为国以礼”、以反问作比较的连贯性立论；赞成第二种，可从师生问答逐层展开、表现善问与善教立论。不能仅以选择哪一种判断正误。\n转载答案给出的分配是：解读差异3分，选择及理由2分。此处用于订正学习参考，不自动重评历史作答。",
          "printedScore": 5,
          "questionSha256": "d84210b98544f361d2ae50ccc2f53a6c9809cdba3430ca27e3d4c4f5c872e172",
          "sourceQIndex": 2
        }
      },
      {
        "answer": "答案：四处说话人依次为——曾皙（曾点）、孔子、曾皙（曾点）、孔子。",
        "difficulty": "medium",
        "explanation": "解析：第二种标点把篇末读作师生问答：凡“唯求则非邦也与？”“唯赤则非邦也与？”是曾皙的追问，“安见方六七十，如五六十而非邦也者？”“宗庙会同，非诸侯而何？赤也为之小，孰能为之大？”是孔子的回答。这与前文“（曾皙）曰：夫子何哂由也？”一问一答的格式一致。",
        "id": "q15",
        "knowledgePoints": [
          "语文",
          "《论语》经典阅读"
        ],
        "prompt": "① 请在括号内写出本句的说话人。（1分）",
        "score": 1,
        "sourceReview": {
          "answer": "依次为：曾皙、孔子、曾皙、孔子。第二种标点把两个“唯……非邦也与”读作曾皙的追问，其后的反问则是孔子的答复。",
          "printedScore": 1,
          "questionSha256": "6f83ccf0c47763557693abd887ae12ca10c44d94d59a8ddc4fd34cb852e9d0db",
          "sourceQIndex": 1
        }
      },
      {
        "answer": "答案：\n两种解读的不同：第一种把“唯求则非邦也与……孰能为之大”全断为孔子一人之言，是孔子评点子路之后自问自答，借以说明冉有、公西华所言也都是治国之事，只因子路“其言不让”才被哂。第二种则断为曾皙与孔子的对话：“唯求则非邦也与”“唯赤则非邦也与”是曾皙发问，其后各句是孔子作答。\n\n我赞成第二种。理由：①篇末本就是曾皙问、孔子答的对话（“夫子何哂由也”即曾皙之问），第二种使这种一问一答贯穿到底，文气连贯；②曾皙连用“唯求则非邦也与”“唯赤则非邦也与”发问，孔子逐一作答，层层辨明“为国”“为邦”之义，结构更清晰；③更能见出曾皙善问、孔子循循善诱的形象。（若赞成第一种，则可言：通篇为孔子一人评点诸子之志，集中表达其“为国以礼”的主张，语意亦自连贯。）",
        "difficulty": "medium",
        "explanation": "",
        "id": "q16",
        "knowledgePoints": [
          "语文",
          "《论语》经典阅读"
        ],
        "prompt": "② 不同的标点源于对文本的不同解读，请简要说明第二种解读与第一种的不同之处。有人认为第二种解读优于第一种，你赞成哪一种？请说明理由。（5分）",
        "score": 5,
        "sourceReview": {
          "answer": "不同之处：第一种读法是曾皙一问、孔子集中作答；第二种是师生连续三次问答。第二种还显出两人的关注点不同：孔子重在是否谦让、是否合礼；曾皙追问的则是，冉有、公西华既然同样谈治国，为何没有受到与子路相同的评价。\n可以赞成任一种，但须说明理由。赞成第一种，可从孔子集中阐明“为国以礼”、以反问作比较的连贯性立论；赞成第二种，可从师生问答逐层展开、表现善问与善教立论。不能仅以选择哪一种判断正误。\n转载答案给出的分配是：解读差异3分，选择及理由2分。此处用于订正学习参考，不自动重评历史作答。",
          "printedScore": 5,
          "questionSha256": "d84210b98544f361d2ae50ccc2f53a6c9809cdba3430ca27e3d4c4f5c872e172",
          "sourceQIndex": 2
        }
      }
    ],
    "referenceAnswer": "",
    "sectionLabel": "《论语》经典阅读",
    "source": "gk.bdfz.net 北京高考语文真题库",
    "sourceReview": {
      "material": "15.《论语·侍坐》篇，子路、曾皙、冉有、公西华分别讲述了自己的志向，孔子\n对子路的话不以为然。篇末是曾皙与孔子师生二人的对话，这一对话存在两种不同的标点，其中一种标点如下。\n\n曰：“夫子何哂由也？”\n\n曰：“为国以礼，其言不让，是故哂之。唯求则非邦也与？安见方六七十，如五六十而非邦也者？唯赤则非邦也与？宗庙会同，非诸侯而何？赤也为之小，孰能为之大？”\n\n另一种标点如下。\n\n曰：“夫子何哂由也？”\n\n曰：“为国以礼，其言不让，是故哂之。”\n\n（ ）“唯求则非邦也与？”\n\n（ ）“安见方六七十，如五六十而非邦也者？”\n\n（ ）“唯赤则非邦也与？”\n\n（ ）“宗庙会同，非诸侯而何？赤也为之小，孰能为之大？”",
      "note": "依据中国教育在线当年转载题面和答案影像核对；不是考试院直接发布件。",
      "officialSource": false,
      "reviewedAt": "2026-10-06T00:10:58.145Z",
      "schema": "weibian-exam-review-v1",
      "sourceRecordId": "2015-lunyu",
      "sources": [
        {
          "bytes": 63656,
          "kind": "contemporaneous_question_image",
          "page": "question 15",
          "sha256": "8cfb4f71fcff413cdb9ec13c06db9f4a09cb415cb26d4136e487dd4621ff28bc",
          "url": "https://img.eol.cn/html/g/2015gkst/bj/yw7.jpg"
        },
        {
          "bytes": 201955,
          "kind": "contemporaneous_answer_scan",
          "page": "printed page 12",
          "sha256": "837a6e6e3c1920f9319dd1b2418307c9898124fd0be40e9c3e1869cf883cd531",
          "url": "https://img.eol.cn/html/g/2015gkst/bj/ywtda2.jpg"
        }
      ],
      "topic": "（二）根据要求，完成第15题。（共6分）"
    },
    "topic": "（二）根据要求，完成第15题。（共6分）",
    "year": 2015
  },
  {
    "answerSource": "gpt_5_5_pro",
    "id": "gk-2018-lunyu",
    "material": "13．《论语》记录了孔子与弟子间的许多对话，如《先进》篇：\n\n子路问：“闻斯【1】行诸？”子曰：“有父兄在，如之何其闻斯行之？”\n\n冉有问：“闻斯行诸？”子曰：“闻斯行之。”\n\n公西华曰：“由也问闻斯行诸，子曰，‘有父兄在’；求也问闻斯行诸，子曰，‘闻斯行之’。赤也惑，敢问。”子曰：“求也退，故进之；由也兼人【2】，故退之。”",
    "modelAnswer": "GPT-5.5 pro 版本答案：\n答题区间：全文。\n\n内容概述：\n1. 对子路：孔子回答不应立即实行，因为有父兄在，需要请示长辈。\n2. 对冉有：孔子回答应该立即实行。\n3. 对公西华：孔子解释了差异的原因，指出冉有性格退缩，所以鼓励他进取；子路性格勇猛过人，所以要压制他一下。\n\n思想内涵：\n本则短文反映了孔子因材施教的教育思想。孔子在面对同一问题时，根据学生子路和冉有不同的性格特点，给予截然不同的回答，旨在纠正学生性格上的偏差，使其达到中庸和谐的状态。\n\n总结：孔子通过差异化的教学手段，体现了针对学生个性实施教育的智慧。",
    "passages": [
      292
    ],
    "province": "北京",
    "questions": [
      {
        "id": "q1",
        "prompt": "请简要概述孔子三次回答的内容，并说明此则短文反映了孔子怎样的思想。",
        "score": null,
        "sourceReview": {
          "answer": "孔子先告诫子路，有父兄在，不可听到道理便擅自行动；随后鼓励冉有听到后便行动；最后向公西华解释，冉有退缩，须鼓励，子路勇于作为，须让他懂得退让。同一问题有不同回答，体现依据学生特点进行教育、因材施教。",
          "printedScore": 5,
          "questionSha256": "98dfa69d7d69d876a6ff1e34071726e5c3334b861e3f7e65a7e445127a11108d",
          "sourceQIndex": 1
        }
      },
      {
        "answer": "答案：\n三次回答：①答子路“闻斯行诸”——“有父兄在”，怎能一听到就去做（应先禀告父兄，不可贸然而行）；②答冉有同一问题——“闻斯行之”，听到了就该去做；③答公西华之惑——冉有平日退缩（“求也退”），所以鼓励他果断去做；子路好勇过人（“由也兼人”），所以让他有所节制。\n\n这则短文反映了孔子“因材施教”的思想：面对同一个问题，孔子针对弟子不同的性格（冉有退缩、子路过勇）给予不同甚至相反的指导，使“过”者抑、“不及”者进，体现了从学生个性差异出发、有的放矢的教育思想（其中也含使人归于中道的中庸之意）。",
        "difficulty": "medium",
        "explanation": "",
        "id": "q15",
        "knowledgePoints": [
          "语文",
          "《论语》经典阅读"
        ],
        "prompt": "请简要概述孔子三次回答的内容，并说明此则短文反映了孔子怎样的思想。",
        "score": null,
        "sourceReview": {
          "answer": "孔子先告诫子路，有父兄在，不可听到道理便擅自行动；随后鼓励冉有听到后便行动；最后向公西华解释，冉有退缩，须鼓励，子路勇于作为，须让他懂得退让。同一问题有不同回答，体现依据学生特点进行教育、因材施教。",
          "printedScore": 5,
          "questionSha256": "98dfa69d7d69d876a6ff1e34071726e5c3334b861e3f7e65a7e445127a11108d",
          "sourceQIndex": 1
        }
      }
    ],
    "referenceAnswer": "13．三次回答内容：孔子说：“父亲和兄长还活着，怎么可以（不先请教他们）听到了就去做呢？”\n孔子说：“听到了应该立刻就去做。”孔子说：“冉求畏缩不前，所以我鼓励他进取；仲由好勇过人，所以提醒他退让些。”\n短文反映了孔子的教育思想：因材施教。结合对每个学生的特点和其不同的品质，给予不同的教育方法和言语指导。",
    "sectionLabel": "《论语》经典阅读",
    "source": "gk.bdfz.net 北京高考语文真题库",
    "sourceReview": {
      "material": "13．《论语》记录了孔子与弟子间的许多对话，如《先进》篇：\n\n子路问：“闻斯【1】行诸？”子曰：“有父兄在，如之何其闻斯行之？”\n\n冉有问：“闻斯行诸？”子曰：“闻斯行之。”\n\n公西华曰：“由也问闻斯行诸，子曰，‘有父兄在’；求也问闻斯行诸，子曰，‘闻斯行之’。赤也惑，敢问。”子曰：“求也退，故进之；由也兼人【2】，故退之。”",
      "note": "依据中国教育在线转载题面及参考答案核对；不是考试院直接发布件。",
      "officialSource": false,
      "reviewedAt": "2026-10-06T00:24:25.667Z",
      "schema": "weibian-exam-review-v1",
      "sourceRecordId": "2018-lunyu",
      "sources": [
        {
          "bytes": 159999,
          "kind": "question_image",
          "page": "page4;Q13 begins",
          "sha256": "a5408eec43cdcc095b0d2faaa9137e74ddc1b643e0f57bdd01312a7d83b47d06",
          "url": "https://gaokao.eol.cn/bei_jing/dongtai/201806/W020200706532908239909.jpg"
        },
        {
          "bytes": 226842,
          "kind": "question_image",
          "page": "page5;Q13 continued",
          "sha256": "1dcc328a8fe1799aeaab71335df178c2a5a5f20d6ee9fd24316a73b16bb6c7bc",
          "url": "https://gaokao.eol.cn/bei_jing/dongtai/201806/W020200706532908243571.jpg"
        },
        {
          "bytes": 180712,
          "kind": "publisher_answer_text",
          "page": "answer13",
          "sha256": "9717c8d6f98e57968c80933853a4455771994d2bdbda6ce155a978be4a5a7a69",
          "url": "https://gaokao.eol.cn/bei_jing/dongtai/201806/t20180607_1606171.shtml"
        }
      ],
      "topic": "（二）根据要求，完成第13题。（共5分）"
    },
    "topic": "（二）根据要求，完成第13题。（共5分）",
    "year": 2018
  },
  {
    "answerSource": "",
    "id": "gk-2018-weixiezuo-lunyu",
    "material": "",
    "modelAnswer": "",
    "passages": [],
    "province": "北京",
    "questions": [
      {
        "id": "q3",
        "prompt": "③读了《论语》，在孔子的众弟子之中，你喜欢颜回，还是曾参，或者其他哪位？请选择一位，为他写一段评语。要求：符合人物特征。150—200字。",
        "score": null,
        "sourceReview": {
          "answer": "这是微写作的第三个备选题，三个题目任选一个作答。选择孔子的一位弟子，写150—200字的评语，关键是评价具体、符合《论语》中的人物特征。例如评价颜回，应把好学或安贫乐道落实到相关言行；评价曾参，可联系反省与责任。人物选择开放，不能把某一篇范文当作唯一答案，也不能把三个选题重复计分。",
          "printedScore": 10,
          "questionSha256": "1cc9f7b8cd02da2ae8ffa0a203b8485a86953467dc0a8f29b9e712237d9847cb",
          "sourceQIndex": 3
        }
      }
    ],
    "referenceAnswer": "",
    "sectionLabel": "微写作（《论语》命题）",
    "source": "gk.bdfz.net 北京高考语文真题库",
    "sourceReview": {
      "material": "",
      "note": "依据中国教育在线题面图版核对写作要求；开放题没有唯一范文。",
      "officialSource": false,
      "reviewedAt": "2026-10-06T00:24:25.668Z",
      "schema": "weibian-exam-review-v1",
      "sourceRecordId": "2018-weixiezuo",
      "sources": [
        {
          "bytes": 116274,
          "kind": "question_image",
          "page": "page8;Q23 option3",
          "sha256": "dc77f4ab372afd35a1e380a0395f27dee816f0e654163883669126ac6cd992c4",
          "url": "https://gaokao.eol.cn/bei_jing/dongtai/201806/W020200706532908287651.jpg"
        }
      ],
      "topic": "五．本大题共2小题，共60分。\n23．微写作（10分）\n从下面三个题目中任选一题，按要求作答。"
    },
    "topic": "五．本大题共2小题，共60分。\n23．微写作（10分）\n从下面三个题目中任选一题，按要求作答。",
    "year": 2018
  },
  {
    "answerSource": "gpt_5_5_pro",
    "id": "gk-2019-lunyu",
    "material": "12．阅读下面《论语》的文字，回答问题。\n\n子曰：“富与贵，是人之所欲也；不以其道得之，不处【1】也。贫与残，是人之所恶也；不以其道得之，不去也。君子去仁，恶乎成名？君子无终食之间违仁，造次【2】必于是，颠沛必于是。”\n\n（《论语・里仁》）",
    "modelAnswer": "GPT-5.5 pro 版本答案：\n小题 1 答案：\n\n一、其道含义：这里的道指的是儒家所倡导的道德准则、仁义原则或正当的获取途径。即获取富贵必须符合礼义规范，不能通过非法或不道德的手段获取。\n\n二、孔子思想：本段表达了孔子重义轻利、坚守仁德的思想。孔子认为，富贵贫贱是人之常情，但君子应始终以仁为本，无论在顺境还是逆境，无论时间长短，都不能背离仁德。仁是君子安身立命的根本，也是衡量君子是否名副其实的标准。\n\n三、总结：该段强调了君子在面对利害得失时，必须始终坚持道德操守，将仁义置于首位。",
    "passages": [
      71
    ],
    "province": "北京",
    "questions": [
      {
        "id": "q1",
        "prompt": "①“不以其道得之，不处也。”本句中的“其道”指什么?全段表达了孔子的什么思想？",
        "score": null,
        "sourceReview": {
          "answer": "“其道”指仁道。全段强调，君子不应为取得富贵或摆脱贫贱而违背仁，即使处境仓促、困顿，也应坚持仁德。",
          "printedScore": null,
          "questionSha256": "4cda9d75a0f573f063e00d5a35e458375e9cf276cf5f6fbcb8e2c1d970a641e6",
          "sourceQIndex": 1
        }
      },
      {
        "id": "q2",
        "prompt": "②“不以其道得之，不去也。”杨伯峻《论语译注》认为，“得之”应改为“去之”；也有学者认为，“不以其道得之”的“不”字应删去。请根据以上两种不同解读，分别解释句意。",
        "score": null,
        "sourceReview": {
          "answer": "改“得之”为“去之”：若不能按仁道摆脱贫贱，就不摆脱贫贱。删去“不”字：若因遵守仁道而陷入贫贱，就安于这种贫贱，不以背弃仁道求脱身。两种解释都守仁，但后者讲的是因守仁而处于贫贱；旧模型把它再次解释为用不正当手段摆脱贫贱，颠倒了这处条件。",
          "printedScore": null,
          "questionSha256": "3e0763a7e2af6c2659c8fca08dd3073d96e3ce3278be9666e40b59f294e61448",
          "sourceQIndex": 2
        }
      },
      {
        "answer": "答案：\n“其道”指正当的方法、途径，即合乎道义（仁）的方式。本句意为：富贵如果不是用正当手段得来的，君子就不去安享它。\n全段思想：君子对待富贵贫贱，取舍一以“仁（道义）”为准则——富贵不苟取，贫贱不苟去，且无论何时何地（终食之间、造次、颠沛）都不离开仁。即“爱财取之有道”、安贫乐道、以仁为立身之本的思想。",
        "difficulty": "medium",
        "explanation": "",
        "id": "q15",
        "knowledgePoints": [
          "语文",
          "《论语》经典阅读"
        ],
        "prompt": "①“不以其道得之，不处也。”本句中的“其道”指什么?全段表达了孔子的什么思想？",
        "score": null,
        "sourceReview": {
          "answer": "“其道”指仁道。全段强调，君子不应为取得富贵或摆脱贫贱而违背仁，即使处境仓促、困顿，也应坚持仁德。",
          "printedScore": null,
          "questionSha256": "4cda9d75a0f573f063e00d5a35e458375e9cf276cf5f6fbcb8e2c1d970a641e6",
          "sourceQIndex": 1
        }
      },
      {
        "answer": "答案：\n①按杨伯峻说（“得之”应作“去之”）：贫贱是人人厌恶的，但如果不能用正当的方法摆脱它，君子宁可不摆脱——即不以不正当手段去除贫贱。\n②按删“不”字说（读作“以其道得之，不去也”）：贫贱虽为人所恶，但如果是由于坚守正道而招致的贫贱（本就该处此境），君子便安然处之、不去摆脱。\n两说虽训释路径不同，但都落到“君子守道、不以不义脱贫贱”这一旨意上。",
        "difficulty": "medium",
        "explanation": "",
        "id": "q16",
        "knowledgePoints": [
          "语文",
          "《论语》经典阅读"
        ],
        "prompt": "②“不以其道得之，不去也。”杨伯峻《论语译注》认为，“得之”应改为“去之”；也有学者认为，“不以其道得之”的“不”字应删去。请根据以上两种不同解读，分别解释句意。",
        "score": null,
        "sourceReview": {
          "answer": "改“得之”为“去之”：若不能按仁道摆脱贫贱，就不摆脱贫贱。删去“不”字：若因遵守仁道而陷入贫贱，就安于这种贫贱，不以背弃仁道求脱身。两种解释都守仁，但后者讲的是因守仁而处于贫贱；旧模型把它再次解释为用不正当手段摆脱贫贱，颠倒了这处条件。",
          "printedScore": null,
          "questionSha256": "3e0763a7e2af6c2659c8fca08dd3073d96e3ce3278be9666e40b59f294e61448",
          "sourceQIndex": 2
        }
      }
    ],
    "referenceAnswer": "12．参考答案：\n①“其道”指仁或仁道。全段表达了君子在任何情况下都不应该离开仁的思想。\n②根据第一种解读，句意为：不是通过仁道脱离贫贱，那么就不离开贫殿，根据第二种解读，句意为：因行仁道而陷入贫贱，那么就不离开贫贱。",
    "sectionLabel": "《论语》经典阅读",
    "source": "gk.bdfz.net 北京高考语文真题库",
    "sourceReview": {
      "material": "12．阅读下面《论语》的文字，回答问题。\n\n子曰：“富与贵，是人之所欲也；不以其道得之，不处【1】也。贫与贱，是人之所恶也；不以其道得之，不去也。君子去仁，恶乎成名？君子无终食之间违仁，造次【2】必于是，颠沛必于是。”\n\n（《论语・里仁》）",
      "note": "依据中国教育在线转载题面及参考答案核对；不是考试院直接发布件。 题面图版总分为7分，旧题库标题写5分；各小问未标分，不能据总分猜测分配。历史成绩及原有分数字段保留。",
      "officialSource": false,
      "reviewedAt": "2026-10-06T00:24:25.668Z",
      "schema": "weibian-exam-review-v1",
      "sourceRecordId": "2019-lunyu",
      "sources": [
        {
          "bytes": 187742,
          "kind": "question_image",
          "page": "printed page5;Q12",
          "sha256": "dac578c777125bd9b7d2fd8dd79c9477c22b263ae7f219c02b10700efbb18da0",
          "url": "https://img.eol.cn/e_images/gk/2019shiti/bj/bjyw5.jpg"
        },
        {
          "bytes": 233421,
          "kind": "publisher_annotated_answer",
          "page": "page9;answer12",
          "sha256": "a2a054d5909922bbd30a48be7eb3a03fb4b65063dec51ea57e7827d4dd1036b7",
          "url": "https://img.eol.cn/e_images/gk/2019shiti/bj/ywd9.JPG"
        }
      ],
      "topic": "（二）根据要求，完成第12题。（共7分）"
    },
    "topic": "（二）根据要求，完成第12题。（共5分）",
    "year": 2019
  },
  {
    "answerSource": "gpt_5_5_pro",
    "id": "gk-2020-lunyu",
    "material": "12.阅读下面《论语》中的文字，回答问题。\n\n子曰：“我非生而知之者，好古，敏以求之者也。”(《述而》)\n\n子曰：“盖有不知而作之者，我无是也。多闻，择其善者而从之，多见而识之，知之次也。”(《述而》)\n\n太宰问于子贡曰：“夫子圣者与？何其多能也？”子贡曰：“固天纵之将圣，又多能也。”\n\n子闻之，曰：“太宰知我乎！吾少也贱，故多能鄙事。君子多乎哉？不多也。”(《子罕》)\n",
    "modelAnswer": "GPT-5.5 pro 版本答案：\n答案：\n生而知之者：指天生就具有知识、不需要学习的人。孔子认为这类人是不存在的，以此强调后天学习的重要性。\n不知而作之者：指自己并不真正了解却随意创造或编造的人。孔子明确表示自己不会这样做，体现了他实事求是的治学态度。",
    "passages": [
      215,
      178,
      170
    ],
    "province": "北京",
    "questions": [
      {
        "id": "q1",
        "prompt": "(1)请解释“生而知之者”与“不知而作之者”。(2分)",
        "score": 2,
        "sourceReview": {
          "answer": "“生而知之者”是生来就具有知识的人；“不知而作之者”是自己不明白却凭空行事、创作的人。孔子说自己不是前者，也不会做后者。原文只是否认自己生而知之，不能推成“孔子认为这样的人不存在”；旧模型的这一附加断言应删去。",
          "printedScore": 2,
          "questionSha256": "8b31c3feed7f17ac4d9eff398fb3b5c58f3995399080ffeb338d836555e36c2b",
          "sourceQIndex": 1
        }
      },
      {
        "id": "q2",
        "prompt": "(2)综合以上材料，简述孔子获取知识的途径，并就其中一点谈谈对你的启示。(4分)",
        "score": 4,
        "sourceReview": {
          "answer": "获取知识的途径包括：钻研古代文化，勤于求知；广泛听闻和观察，选择可取之处学习并记住；在实际生活劳动中学习技能。启示须联系其中一点展开。例如面对信息，既要广泛阅读，也要核查来源、比较证据，辨别后再吸收。不能只列途径而遗漏自己的启示。",
          "printedScore": 4,
          "questionSha256": "49e61acb47ccd570869613b1f07d8010ddbecaab2a09082a84f2d34ff7394dcf",
          "sourceQIndex": 2
        }
      },
      {
        "answer": "答案：\n“生而知之者”：生来（不待学习）就懂得知识、道理的人——孔子说“我非生而知之者”，否认自己天生即知。\n“不知而作之者”：不懂、不了解实情却凭空创作、妄下论断（穿凿臆造）的人——孔子说“我无是也”，表示自己不做这种没有根据的臆造。",
        "difficulty": "medium",
        "explanation": "",
        "id": "q16",
        "knowledgePoints": [
          "语文",
          "《论语》经典阅读"
        ],
        "prompt": "请解释“生而知之者”与“不知而作之者”。(2分)",
        "score": 2,
        "sourceReview": {
          "answer": "“生而知之者”是生来就具有知识的人；“不知而作之者”是自己不明白却凭空行事、创作的人。孔子说自己不是前者，也不会做后者。原文只是否认自己生而知之，不能推成“孔子认为这样的人不存在”；旧模型的这一附加断言应删去。",
          "printedScore": 2,
          "questionSha256": "8b31c3feed7f17ac4d9eff398fb3b5c58f3995399080ffeb338d836555e36c2b",
          "sourceQIndex": 1
        }
      },
      {
        "answer": "答案：\n孔子获取知识的途径：①“好古，敏以求之”——爱好古代文化典籍，勤勉努力地探求；②“多闻，择其善者而从之，多见而识之”——广闻博见，择善而从、多见而记；③“吾少也贱，故多能鄙事”——出身贫贱，从生活实践中习得多种技能。归结为：勤学好古、多闻多见而择善、在实践中求知。\n启示（任举一点）：如“择其善者而从之”——面对纷繁的见闻信息，要有辨别取舍的能力，择善而学、去芜存菁；又如“敏以求之”——知识非生而能知，唯勤勉求索方有所得，后天努力比天资更可贵。（言之成理即可。）",
        "difficulty": "medium",
        "explanation": "",
        "id": "q17",
        "knowledgePoints": [
          "语文",
          "《论语》经典阅读"
        ],
        "prompt": "综合以上材料，简述孔子获取知识的途径，并就其中一点谈谈对你的启示。(4分)",
        "score": 4,
        "sourceReview": {
          "answer": "获取知识的途径包括：钻研古代文化，勤于求知；广泛听闻和观察，选择可取之处学习并记住；在实际生活劳动中学习技能。启示须联系其中一点展开。例如面对信息，既要广泛阅读，也要核查来源、比较证据，辨别后再吸收。不能只列途径而遗漏自己的启示。",
          "printedScore": 4,
          "questionSha256": "49e61acb47ccd570869613b1f07d8010ddbecaab2a09082a84f2d34ff7394dcf",
          "sourceQIndex": 2
        }
      }
    ],
    "referenceAnswer": "",
    "sectionLabel": "《论语》经典阅读",
    "source": "gk.bdfz.net 北京高考语文真题库",
    "sourceReview": {
      "material": "12.阅读下面《论语》中的文字，回答问题。\n\n子曰：“我非生而知之者，好古，敏以求之者也。”(《述而》)\n\n子曰：“盖有不知而作之者，我无是也。多闻，择其善者而从之，多见而识之，知之次也。”(《述而》)\n\n太宰问于子贡曰：“夫子圣者与？何其多能也？”子贡曰：“固天纵之将圣，又多能也。”\n\n子闻之，曰：“太宰知我乎！吾少也贱，故多能鄙事。君子多乎哉？不多也。”(《子罕》)",
      "note": "依据中国教育在线转载题面及参考答案核对；不是考试院直接发布件。",
      "officialSource": false,
      "reviewedAt": "2026-10-06T00:24:25.668Z",
      "schema": "weibian-exam-review-v1",
      "sourceRecordId": "2020-lunyu",
      "sources": [
        {
          "bytes": 120787,
          "kind": "question_image",
          "page": "page5;Q12",
          "sha256": "080ef4122695deb11404a8f161ffd33296be0950ea273a7aa6125202812f7262",
          "url": "https://gaokao.eol.cn/shiti/zhenti/202102/W020210222533345985699.jpg"
        },
        {
          "bytes": 92055,
          "kind": "publisher_answer_image",
          "page": "page11;answer12",
          "sha256": "a6386980e036394b3faf169f886cf8f27a5198b4e7d6ade0a26ac0fbb50e346d",
          "url": "https://gaokao.eol.cn/shiti/zhenti/202102/W020210222533346055189.jpg"
        }
      ],
      "topic": "(二)根据要求，完成第12题。(共6分)"
    },
    "topic": "(二)根据要求，完成第12题。(共6分)",
    "year": 2020
  },
  {
    "answerSource": "gpt_5_5_pro",
    "id": "gk-2021-lunyu",
    "material": "子曰：“由也！女闻六言【注】六蔽矣乎？”对曰：“未也。”\n\n“居！吾语女。好仁不好学，其蔽也愚；好知不好学，其蔽也荡；好信不好学，其蔽也贼；好直不好学，其蔽也绞；好勇不好学，其蔽也乱；好刚不好学，其蔽也狂。”\n\n（《阳货》）",
    "modelAnswer": "GPT-5.5 pro 版本答案：\n答案：孔子之所以将学习与道德修养联系在一起，是因为单纯的道德品质如果缺乏学习的引导与规范，就会走向极端，产生负面效应（蔽）。学习不仅是获取知识，更是对道德实践的理性审视与修正，能避免道德理想在实际操作中流于片面和偏激。\n\n选择分析：\n1. 好仁不好学，其蔽也愚：仁爱之心如果没有学习来开启智慧，往往容易流于妇人之仁，不辨是非，最终导致愚昧无知，无法产生真正的社会价值。\n2. 好勇不好学，其蔽也乱：如果一个人只有勇敢的品质却不学习礼仪与谋略，在处理事务时往往会鲁莽行事，不计后果，最终不仅不能解决问题，反而会导致秩序混乱，危害集体。",
    "passages": [
      484
    ],
    "province": "北京",
    "questions": [
      {
        "id": "q1",
        "prompt": "孔子为什么把学习与道德修养联系在一起？请从“六言六蔽”中任选两个，用自己的话加以解释。",
        "score": null,
        "sourceReview": {
          "answer": "学习能帮助人辨明行为的分寸，使好的品质不致因片面发展而成为弊病。例如，爱好仁德而不学习辨别，容易愚昧受骗；勇敢而不学习判断、约束行动，容易好斗作乱。也可以选择其余四项中的任意两项解释，但须把所好之德与不学习造成的弊病联系起来，不要求固定选“仁”和“勇”。",
          "printedScore": 6,
          "questionSha256": "3868f83ad29f519a20188b306171829c8d07534c31af5e8e809217f4ba7f4345",
          "sourceQIndex": 1
        }
      },
      {
        "answer": "答案：\n孔子之所以把学习与道德修养联系在一起：因为仁、知、信、直、勇、刚等美德（“六言”），若只一味喜好而“不好学”（不学礼义、不明事理），就会失去节制与分寸，反而生出相应的弊病（“六蔽”）；唯有以“学”来指导、约束，美德才能恰到好处地成就，不致流于偏失。故修德不可离学。\n任选两例（用自己的话）：\n·“好仁不好学，其蔽也愚”——只知一味行仁却不学习、不明事理，就容易被人愚弄、是非不分，流于愚昧。\n·“好勇不好学，其蔽也乱”——只崇尚勇敢而不学习、不知礼义节制，就会鲁莽妄为、犯上作乱。\n（“好知不好学，其蔽也荡”——逞智而不学则放荡无归；“好信不好学，其蔽也贼”——死守信用而不知变通反而害己；“好直不好学，其蔽也绞”——一味直率则尖刻伤人；“好刚不好学，其蔽也狂”——刚强而不学则狂妄。任选两个即可。）",
        "difficulty": "medium",
        "explanation": "",
        "id": "q17",
        "knowledgePoints": [
          "语文",
          "《论语》经典阅读"
        ],
        "prompt": "孔子为什么把学习与道德修养联系在一起？请从“六言六蔽”中任选两个，用自己的话加以解释。",
        "score": null,
        "sourceReview": {
          "answer": "学习能帮助人辨明行为的分寸，使好的品质不致因片面发展而成为弊病。例如，爱好仁德而不学习辨别，容易愚昧受骗；勇敢而不学习判断、约束行动，容易好斗作乱。也可以选择其余四项中的任意两项解释，但须把所好之德与不学习造成的弊病联系起来，不要求固定选“仁”和“勇”。",
          "printedScore": 6,
          "questionSha256": "3868f83ad29f519a20188b306171829c8d07534c31af5e8e809217f4ba7f4345",
          "sourceQIndex": 1
        }
      }
    ],
    "referenceAnswer": "11．答案要点：\n①通过学习可以加强或提升道德修养，如果不学习就会产生各种弊病。\n②“好仁”二句：追求仁德而不喜好学习，它的弊病是憨傻易欺。\n“好知”二句：喜好聪慧却不喜好学习，它的弊病是放荡无守。“好信”二句：讲求诚信却不喜好学习，它的弊病是带来伤害。“好直”二句：讲求直率而不喜好学习，它的弊病是尖刻伤人。“好勇”二句：追求勇敢却不喜好学习，它的弊病是好斗作乱。“好刚”二句：喜好刚强却不喜好学习，它的弊病是狂妄自大。（答出其中的两个即可）",
    "sectionLabel": "《论语》经典阅读",
    "source": "gk.bdfz.net 北京高考语文真题库",
    "sourceReview": {
      "material": "子曰：“由也！女闻六言【注】六蔽矣乎？”对曰：“未也。”\n\n“居！吾语女。好仁不好学，其蔽也愚；好知不好学，其蔽也荡；好信不好学，其蔽也贼；好直不好学，其蔽也绞；好勇不好学，其蔽也乱；好刚不好学，其蔽也狂。”\n\n（《阳货》）",
      "note": "依据中国教育在线转载题面及参考答案核对；不是考试院直接发布件。",
      "officialSource": false,
      "reviewedAt": "2026-10-06T00:24:25.668Z",
      "schema": "weibian-exam-review-v1",
      "sourceRecordId": "2021-lunyu",
      "sources": [
        {
          "bytes": 651521,
          "kind": "question_image",
          "page": "printed page4;Q11",
          "sha256": "2ee03f8f3c73c697a036915fb3dd743ad28c5c1a8d9ac0284201f1d042b90fb2",
          "url": "https://img.eol.cn/e_images/gk/2020/2021sj/bj/yw04.png"
        },
        {
          "bytes": 544413,
          "kind": "publisher_answer_image",
          "page": "printed page9;answer11",
          "sha256": "c6a25d7863903fb3362a5165d6eda1c0f942033f05d8c416d82e8b5f459cbb76",
          "url": "https://img.eol.cn/e_images/gk/2020/2021sj/bj/ywd01.png"
        }
      ],
      "topic": "11. 阅读下面《论语》中的文字，回答问题。"
    },
    "topic": "11. 阅读下面《论语》中的文字，回答问题。",
    "year": 2021
  },
  {
    "answerSource": "gpt_5_5_pro",
    "id": "gk-2023-lunyu",
    "material": "①子曰：“君子疾没世而名不称焉。”（《论语·卫灵公》）\n\n②子曰：“君子病无能焉，不病人之不已知也。”（《论语·卫灵公》）\n\n③子曰：“君子病没世而名不称焉。吾道不行矣，吾何以自见于后世哉？”（《史记·孔子世家》）\n\n④先生（王阳明）曰：“为学大病在好名。……'疾没世而名不称’，'称’字去声①读，亦‘声闻过情，君子耻之’②之意。”（《传习录》）\n",
    "modelAnswer": "GPT-5.5 pro 版本答案：\n杨伯峻的解读：读音为平声，意为被人们称道、赞誉。他将“名不称”理解为名声没有被世人所传扬。\n王阳明的解读：明确指出“称”字读去声（第四声），意为“相当、符合”。他认为此处的“称”与“声闻过情，君子耻之”含义相通，即名声与实际情况相符合，而非追求虚名。",
    "passages": [
      439,
      440
    ],
    "province": "北京",
    "questions": [
      {
        "id": "q1",
        "prompt": "对于①中画线的句子有两种解读，今人杨伯峻的解读是“到死而名声不被人家称述，君子引以为恨”。④是明代思想家王阳明的解读，与杨伯峻有所不同。\n（1）说明杨、王两种解读对“称”的读音和词义的理解有何不同。（2分）",
        "score": 2,
        "sourceReview": {
          "answer": "杨伯峻将“称”读作 chēng，解释为称述、称道；王阳明将“称”读作 chèn，解释为相称、符合，即名声与实际德行相称。旧参考答案把后一义写成“名词，名声”，应予订正。题目要求辨析读音和词义，无须另加词性作为评分条件。",
          "printedScore": null,
          "questionSha256": "adc83f8948db48c3069bc77ac64f5df26e9180f81cd236e9f95b320030e9359a",
          "sourceQIndex": 1
        }
      },
      {
        "id": "q2",
        "prompt": "（2）用自己的话写出王阳明对①“君子疾没世而名不称焉”解读的大意。（2分）",
        "score": 2,
        "sourceReview": {
          "answer": "君子担忧的是，到生命结束时，自己的德行与所享有的名声仍不相称，名声超出实际。这种解读强调充实德行，避免徒有其名，而不是为自己没有知名度而忧虑。",
          "printedScore": null,
          "questionSha256": "1cf887d41e52c40d156b2dd6f3e080456613075c3d7bb3968590df67b459b3f4",
          "sourceQIndex": 2
        }
      },
      {
        "id": "q3",
        "prompt": "（3）在杨、王两种解读中任选一种，从上述材料中找出依据，简要解释其合理性。（6分）",
        "score": 6,
        "sourceReview": {
          "answer": "任选一种，并把依据与解释连起来。选择杨伯峻，可用材料③中孔子担忧自己的道不能推行、不能为后世所知，说明他重视有实际内容的身后之名。选择王阳明，可用材料②中君子担忧自己无能而不担忧别人不了解自己，说明君子应重实德、实能，警惕名声超过实际。观点相反不等于其中一种必错，关键在材料支持和解释是否成立。",
          "printedScore": null,
          "questionSha256": "3da9a029671ba48543e93252325217850cfcfe8d35ab2bf295e6270a64069ad0",
          "sourceQIndex": 3
        }
      },
      {
        "answer": "答案：\n杨伯峻：“称”读平声（chēng），意为“称述、称道”；“名不称”即名声不被人称述、传扬。\n王阳明：“称”读去声（chèn），意为“相称、符合”；“名不称”即名声与实际（才德）不相符（名过其实）。",
        "difficulty": "medium",
        "explanation": "",
        "id": "q15",
        "knowledgePoints": [
          "语文",
          "《论语》经典阅读"
        ],
        "prompt": "对于①中画线的句子有两种解读，今人杨伯峻的解读是“到死而名声不被人家称述，君子引以为恨”。④是明代思想家王阳明的解读，与杨伯峻有所不同。\n（1）说明杨、王两种解读对“称”的读音和词义的理解有何不同。（2分）",
        "score": 2,
        "sourceReview": {
          "answer": "杨伯峻将“称”读作 chēng，解释为称述、称道；王阳明将“称”读作 chèn，解释为相称、符合，即名声与实际德行相称。旧参考答案把后一义写成“名词，名声”，应予订正。题目要求辨析读音和词义，无须另加词性作为评分条件。",
          "printedScore": null,
          "questionSha256": "adc83f8948db48c3069bc77ac64f5df26e9180f81cd236e9f95b320030e9359a",
          "sourceQIndex": 1
        }
      },
      {
        "answer": "答案：\n王阳明认为：君子所担忧、引以为耻的，是到死时自己的名声与实际的德行才能不相称——即徒有虚名、名过其实；而不是怕死后不被人称道。换言之，君子耻于“声闻过情”，而非慕求虚名。",
        "difficulty": "medium",
        "explanation": "",
        "id": "q16",
        "knowledgePoints": [
          "语文",
          "《论语》经典阅读"
        ],
        "prompt": "用自己的话写出王阳明对①“君子疾没世而名不称焉”解读的大意。（2分）",
        "score": 2,
        "sourceReview": {
          "answer": "君子担忧的是，到生命结束时，自己的德行与所享有的名声仍不相称，名声超出实际。这种解读强调充实德行，避免徒有其名，而不是为自己没有知名度而忧虑。",
          "printedScore": null,
          "questionSha256": "1cf887d41e52c40d156b2dd6f3e080456613075c3d7bb3968590df67b459b3f4",
          "sourceQIndex": 2
        }
      },
      {
        "answer": "答案：\n（选王阳明说）依据与合理性：①王阳明自言“为学大病在好名”，并引《孟子》“声闻过情，君子耻之”为证，可见他把“名不称”解为“名实不符”，与其“耻虚名、重实德”的为学主张一以贯之；②材料②“君子病无能焉，不病人之不已知也”——君子只忧自身无能（无实），不忧别人不了解自己（不慕虚名），正与王说“耻名过其实、重实轻名”相通。故王说在《论语》内部与所引《孟子》中都能得到呼应，自有其理。\n（若选杨伯峻说）依据与合理性：①材料③《史记·孔子世家》作“君子病没世而名不称焉。吾道不行矣，吾何以自见于后世哉”——孔子忧的是“道不行”“无以自见于后世”，即怕一生之道与名不能传扬后世，正合“名声不被称述”之解；②“疾没世”着眼于身后之名能否流传，亦支持“称述”一义。故杨说有《史记》与文本语境为据，亦属合理。（任选一种，依据充分、解释成理即可。）",
        "difficulty": "medium",
        "explanation": "",
        "id": "q17",
        "knowledgePoints": [
          "语文",
          "《论语》经典阅读"
        ],
        "prompt": "在杨、王两种解读中任选一种，从上述材料中找出依据，简要解释其合理性。（6分）",
        "score": 6,
        "sourceReview": {
          "answer": "任选一种，并把依据与解释连起来。选择杨伯峻，可用材料③中孔子担忧自己的道不能推行、不能为后世所知，说明他重视有实际内容的身后之名。选择王阳明，可用材料②中君子担忧自己无能而不担忧别人不了解自己，说明君子应重实德、实能，警惕名声超过实际。观点相反不等于其中一种必错，关键在材料支持和解释是否成立。",
          "printedScore": null,
          "questionSha256": "3da9a029671ba48543e93252325217850cfcfe8d35ab2bf295e6270a64069ad0",
          "sourceQIndex": 3
        }
      }
    ],
    "referenceAnswer": "11．参考答案：\n（1）杨伯峻的解读“称”读第一声，动词，称述；王阳明的解读，“称”读第四声，名词，名声。\n（2）君子以死后名不副实（名声超过实情）为忧虑。\n（3）示例一（选择杨伯峻的解读）：\n《史记·孔子世家》中孔子自述，“吾道不行矣，吾何以自见于后世哉？”“见”，同“现”，意为表现自己。孔子意在通过立言，使自己的主张为后世所知，并影响后世。说明孔子并非不重身后之名。\n示例二（选择王阳明的解读）：\n《论语·卫灵公》中孔子说，“君子病无能焉，不病人之不己知也。”意为君子只忧虑自己没有能力，不忧虑别人不知道自己。说明孔子并不看重别人是否知道自己。《传习录》中王阳明认为，为学在于自身修养的提升，如果过于看重名声，就有悖于为学的初衷。所以，孔子所“疾”的，是死后名不副实。",
    "sectionLabel": "《论语》经典阅读",
    "source": "gk.bdfz.net 北京高考语文真题库",
    "sourceReview": {
      "material": "①子曰：“君子疾没世而名不称焉。”（《论语·卫灵公》）\n\n②子曰：“君子病无能焉，不病人之不己知也。”（《论语·卫灵公》）\n\n③子曰：“君子病没世而名不称焉。吾道不行矣，吾何以自见于后世哉？”（《史记·孔子世家》）\n\n④先生（王阳明）曰：“为学大病在好名。……'疾没世而名不称’，'称’字去声①读，亦‘声闻过情，君子耻之’②之意。”（《传习录》）",
      "note": "已核对中国教育在线题面图版、参考答案及北京高考在线解析；均为转载件，正式分项评分细则仍待核。 题面图版确认总分10分，未显示逐项配分；现有2/2/6分配暂不据此认定为原卷配分。",
      "officialSource": false,
      "reviewedAt": "2026-10-06T00:24:25.668Z",
      "schema": "weibian-exam-review-v1",
      "sourceRecordId": "2023-lunyu",
      "sources": [
        {
          "bytes": 509169,
          "kind": "question_image",
          "page": "printed page5;Q11",
          "sha256": "695c36388729ffa706feed30052fb20e677f4ca67c9323551777243e500364ff",
          "url": "https://img.eol.cn/e_images/gk/2023/2023st/bj/yw05.png"
        },
        {
          "bytes": 406022,
          "kind": "publisher_answer_image",
          "page": "printed page10;answer11",
          "sha256": "8166d6f381c8106661e7e59197af4570011fea6c31318fcdb9c88d44ea99a672",
          "url": "https://img.eol.cn/e_images/gk/2023/2023st/bj/yw10.png"
        },
        {
          "bytes": 2837601,
          "kind": "annotated_reference_pdf",
          "page": "PDF page 12",
          "sha256": "151b64ebe781415aa8e0f7676518d67fd7902cd43be981bd84c8f58620b6f19c",
          "url": "https://cdn.gaokzx.com/zixunzhan/202403/d0e840b8-8603-4cee-81aa-5e1f1482a091.pdf"
        }
      ],
      "topic": "（二）根据要求，完成第11题。（共10分）"
    },
    "topic": "（二）根据要求，完成第11题。（共10分）",
    "year": 2023
  }
]
